<script setup lang="ts"></script>

<template>
	<div class="grow">
		<slot />
	</div>
</template>
